var map = {
	"./davilas-banner.jpeg": 236,
	"./davilas-logo.jpg": 760,
	"./doña-tota-banner.jpeg": 706,
	"./doña-tota-logo.jpg": 358,
	"./nikkori-banner.png": 912,
	"./nikkori-logo.jpg": 427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 508;